angular.module('dealerware.web.data').factory('DealerwareCreditCardCollection', function ($http,Collection,DealerwareCreditCardModel,$q) {

    'use strict';
    var collection = new Collection({
        baseEndpoint: '/locations/:location_id/customers/:customer_id/credit_cards',
        model: 'DealerwareCreditCardModel',
        customActions: {
            index: {
                method: 'GET',
                ignoreDefaultRootNodeRequest: true,
                ignoreDefaultAssociationMapper: true
            }
        },
        responseTransforms: {
            index: function(args, data) {
                data.forEach(function(cc) {
                    if (cc.data.expiration_month && cc.data.expiration_year) {
                        cc.data.expiration = ('00' + cc.data.expiration_month).slice(-2) + '/' + cc.data.expiration_year;
                    }
                    if (cc.data.last_four) {
                        cc.data.number = '**** **** **** ' + cc.data.last_four;
                    }
                });
            }
        }
    });

    return collection;
});